export const messages = {
  en: {
    listOwner: {
      title: 'Owner Management',
      searchTitle: 'Search Conditions',
      ownerInfo: 'Owner Information',
      selectRoom: 'Select Room',
      role: {
        all: 'All',
        owner: 'Owner',
        tenant: 'Tenant'
      },
      personType: {
        personal: 'Personal',
        company: 'Company'
      },
      personTypeName: 'Person Type',
      gender: {
        male: 'Male',
        female: 'Female'
      },
      columns: {
        face: 'Face',
        name: 'Name',
        type: 'Type',
        role: 'Role',
        gender: 'Gender',
        idCard: 'ID Card',
        phone: 'Phone',
        backupPhone: 'Backup Phone',
        address: 'Address',
        rooms: 'Rooms',
        members: 'Members',
        cars: 'Cars',
        debts: 'Debts',
        operation: 'Operation'
      },
      placeholders: {
        name: 'Please enter name',
        room: 'Building-Unit-Room',
        phone: 'Please enter phone',
        idCard: 'Please enter ID card'
      },
      buttons: {
        search: 'Search',
        reset: 'Reset',
        add: 'Add',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        bindRoom: 'Bind Room',
        unbindRoom: 'Unbind Room',
        member: 'Member',
        detail: 'Detail'
      },
      actions: {
        editOwner: 'Edit Owner',
        editMember: 'Edit Member',
        deleteOwner: 'Delete Owner',
        addRoom: 'Add Room'
      },
      confirmDelete: 'Are you sure to delete?'
    }
  },
  zh: {
    listOwner: {
      title: '业主管理',
      searchTitle: '查询条件',
      ownerInfo: '业主信息',
      selectRoom: '选择房屋',
      role: {
        all: '全部',
        owner: '业主',
        tenant: '租客'
      },
      personType: {
        personal: '个人',
        company: '公司'
      },
      personTypeName: '人员类型',
      gender: {
        male: '男',
        female: '女'
      },
      columns: {
        face: '人脸',
        name: '客户名称',
        type: '人员类型',
        role: '人员角色',
        gender: '性别',
        idCard: '证件号',
        phone: '联系手机',
        backupPhone: '备用手机',
        address: '地址',
        rooms: '房屋数',
        members: '业主成员',
        cars: '车辆数',
        debts: '欠费',
        operation: '操作'
      },
      placeholders: {
        name: '请输入客户名称',
        room: '楼栋-单元-房屋',
        phone: '请输入联系方式',
        idCard: '请输入业主身份证号'
      },
      buttons: {
        search: '查询',
        reset: '重置',
        add: '添加',
        save: '保存',
        cancel: '取消',
        edit: '修改',
        delete: '删除',
        bindRoom: '入住房屋',
        unbindRoom: '房屋解绑',
        member: '成员',
        detail: '详情'
      },
      actions: {
        editOwner: '修改业主',
        editMember: '修改成员',
        deleteOwner: '删除业主',
        addRoom: '入住房屋'
      },
      confirmDelete: '确认是否删除！'
    }
  },
  'zh-TW': {
    listOwner: {
      title: '業主管理',
      searchTitle: '查詢條件',
      ownerInfo: '業主信息',
      selectRoom: '選擇房屋',
      role: {
        all: '全部',
        owner: '業主',
        tenant: '租客'
      },
      personType: {
        personal: '個人',
        company: '公司'
      },
      personTypeName: '人員類型',
      gender: {
        male: '男',
        female: '女'
      },
      columns: {
        face: '人臉',
        name: '客戶名稱',
        type: '人員類型',
        role: '人員角色',
        gender: '性別',
        idCard: '證件號',
        phone: '聯繫手機',
        backupPhone: '備用手機',
        address: '地址',
        rooms: '房屋數',
        members: '業主成員',
        cars: '車輛數',
        debts: '欠費',
        operation: '操作'
      },
      placeholders: {
        name: '請輸入客戶名稱',
        room: '樓棟-單元-房屋',
        phone: '請輸入聯繫方式',
        idCard: '請輸入業主身份證號'
      },
      buttons: {
        search: '查詢',
        reset: '重置',
        add: '添加',
        save: '保存',
        cancel: '取消',
        edit: '修改',
        delete: '刪除',
        bindRoom: '入住房屋',
        unbindRoom: '房屋解綁',
        member: '成員',
        detail: '詳情'
      },
      actions: {
        editOwner: '修改業主',
        editMember: '修改成員',
        deleteOwner: '刪除業主',
        addRoom: '入住房屋'
      },
      confirmDelete: '確認是否刪除！'
    }
  }
}